{
    "id": "3912e960-7795-434f-bc47-d277ff43937e",
    "status_id": "00c97e98-4fa6-485f-9043-874f8d2ca493",
    "product_id": "e96c143d-4240-4844-8242-d427d23c7de5",
    "user_id": "19ffb333-60c2-4336-b75c-517197978870",
    "client_details_id": "2dc61856-47d9-46f6-a218-0d843af5fe6d",
    "active": true,
    "id_code": "0000",
    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
    "id_application": 2744,
    "status_catalog": {
        "id": "00c97e98-4fa6-485f-9043-874f8d2ca493",
        "name": "Cliente con Pendientes",
        "code": "CSFIE",
        "url": "/producto/creditosimple/bofu_completado",
        "url_actual": "/producto/creditosimple/bofu_completado",
        "sub_stage": null
    },
    "previous_status": {
        "id": "4d06d489-08db-44ba-ac01-41b30dda63fc",
        "name": "Registro Usuario",
        "code": "CSRUS",
        "url": "/producto/creditosimple/registro_datos_personales"
    },
    "current_status": {
        "id": "00c97e98-4fa6-485f-9043-874f8d2ca493",
        "name": "Cliente con Pendientes",
        "code": "CSFIE",
        "url": "/producto/creditosimple/bofu_completado"
    },
    "next_status": {
        "id": "f4d8f1f5-2455-4547-8820-b876f0fbf35e",
        "name": "Cliente",
        "code": "CSCLI",
        "url": "/producto/creditosimple/bofu_completado"
    },
    "tax_systems": {
        "id": "78303173-1288-411f-8692-ebec2b6d75ae",
        "name": "Crédito Simple PM",
        "code": "CS001",
        "description": "Crédito Simple para PM",
        "min_amount": 200000,
        "max_amount": 2500000,
        "min_term": 6,
        "max_term": 24,
        "tax_system_type": "PM"
    },
    "interested": null,
    "completed": true,
    "loan_application_completed": null,
    "references_completed": null,
    "bank_information_completed": null,
    "identity_validation_completed": null,
    "ocular_visit": null,
    "approved_amount": 0,
    "approved_term": 0,
    "interest_rate": 0,
    "source_code": null,
    "is_correct_ciec": false,
    "decision_validated": null,
    "score": null,
    "score_code": null,
    "loan_application_conditions": [
        {
            "id": "2584ff13-2ac9-4b92-b217-99daf3f90c0c",
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "loan_amount": 2000000,
            "approved_term": 0,
            "requested_amount": 2000000,
            "approved_amount": 2000000,
            "selected_amount": 2000000,
            "requested_term": 36,
            "approved_max_term": 36,
            "approved_min_term": 18,
            "selected_term": 36,
            "interest_rate": 29,
            "residual_value": 0,
            "monthly_payment": 0,
            "score": 0,
            "score_code": "-",
            "active": true,
            "id_model": "8ed8b831-95e3-45e5-b5bc-9ba059184888",
            "date_model": "2025-12-18T20:02:20.904202",
            "minimum_percentage_dispersion": null,
            "maximum_percentage_dispersion": null,
            "external_rating_id": null,
            "requested_advance_value": null,
            "approved_max_advance_value": null,
            "approved_min_advance_value": null,
            "selected_advance_value": null,
            "requested_residual_value": null,
            "approved_max_residual_value": null,
            "approved_min_residual_value": null,
            "selected_residual_value": null,
            "requested_advance_percentage": null,
            "approved_max_advance_percentage": null,
            "approved_min_advance_percentage": null,
            "selected_advance_percentage": null,
            "requested_residual_percentage": null,
            "approved_max_residual_percentage": null,
            "approved_min_residual_percentage": null,
            "selected_residual_percentage": null
        }
    ],
    "loan_application_bank_account": [
        {
            "id": "a4c66620-922d-4ee4-aea1-119074ac10d8",
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "clabe": "072730011123061103",
            "account": 0,
            "account_holder": "",
            "bank_id": "1b3acea1-7ada-4e1d-b5ca-558113450f55",
            "client_details_id": "5d91adf6-b12d-409a-b0ce-09a681ba5110",
            "person_id": null,
            "bank_statment_first_documents_id": null,
            "bank_statment_second_documents_id": null,
            "bank_statment_third_documents_id": null,
            "principal": false,
            "bank": {
                "id": "1b3acea1-7ada-4e1d-b5ca-558113450f55",
                "name": "BANORTE",
                "description": "Banco Mercantil del Norte, S.A., Institución de Banca Múltiple, GrupoFinanciero Banorte",
                "code": "072"
            }
        },
        {
            "id": "6e09138d-e3ed-40f3-b37b-2e5dcae38641",
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "clabe": "002730701161431761",
            "account": 0,
            "account_holder": "",
            "bank_id": "e069d1bc-f6df-4cae-b744-b94e177253c6",
            "client_details_id": null,
            "person_id": "bff74e85-7c4d-4b33-b177-a619e9ddb97c",
            "bank_statment_first_documents_id": null,
            "bank_statment_second_documents_id": null,
            "bank_statment_third_documents_id": null,
            "principal": false,
            "bank": {
                "id": "e069d1bc-f6df-4cae-b744-b94e177253c6",
                "name": "BANAMEX",
                "description": "Banco Nacional de México, S.A., Institución de Banca Múltiple, Grupo Financiero Banamex",
                "code": "002"
            }
        },
        {
            "id": "43bff85b-7ae7-4e70-8de8-336554e86639",
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "clabe": "012730001176604480",
            "account": 0,
            "account_holder": "0117660448",
            "bank_id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
            "client_details_id": "5d91adf6-b12d-409a-b0ce-09a681ba5110",
            "person_id": null,
            "bank_statment_first_documents_id": null,
            "bank_statment_second_documents_id": null,
            "bank_statment_third_documents_id": null,
            "principal": true,
            "bank": {
                "id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
                "name": "BBVA",
                "description": "BBVA Bancomer, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA Bancomer",
                "code": "012"
            }
        }
    ],
    "credit_validated": null,
    "pld_validated": null,
    "legal_incidents_validated": null,
    "visit_analysis_validated": null,
    "check_control_validated": null,
    "opening_fee": 4.5,
    "cfdi_use_code": "G03",
    "sector_empresarial": "PRIVADO",
    "signature_date": null,
    "disburment_date": "2026-01-07T00:00:00",
    "client_external_created": true,
    "credit_line_external_created": null,
    "contract_external_created": null,
    "portfolio_registration_requested": null,
    "portfolio_operation_sent": null,
    "portfolio_operation_released": null,
    "treasury_dispersal_request": null,
    "clabe_deposit_account": null,
    "initial_date": null,
    "operation_manager_id": null,
    "signature_type": "DIGITAL",
    "guarantee_type_id": null,
    "description_guarantee": "",
    "financed_services_id": null,
    "financed_services": null,
    "created_at": "2026-02-24T00:46:36.792476",
    "is_visit_required": null,
    "folio_number_external": null,
    "loan_reference_external": null,
    "loan_reference_external_sended": null,
    "origination_external_created_at": "2026-01-08T04:01:35.274585+00:00",
    "committee_presentation_date": "2025-12-22T00:00:00",
    "company_id": "c18231ff-3054-41dc-95f9-9e755eb8dcbc",
    "id_application_company": 13,
    "reasons_rejection_application": null,
    "loan_application_information_status": "VALIDADO",
    "references_status": "VALIDADO",
    "bank_information_status": "VALIDADO",
    "gps_monthly_income": null,
    "monthly_cut_off_date": null,
    "leasing_type_id": null,
    "is_credit_bureau_authorization_pf_sended": null,
    "is_credit_bureau_authorization_pf_correct": null
}
